import { render } from "./Participantes.vue?vue&type=template&id=492b9c80"
import script from "./Participantes.vue?vue&type=script&lang=js"
export * from "./Participantes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__